import React from 'react';
import {
    Box,
    Button,
    FormControl,
    FormLabel,
    Input,
    FormErrorMessage,
    Heading,
    VStack,
    useToast,
} from '@chakra-ui/react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import CommonService from '../services/CommonService';

const schema = yup.object().shape({
    currentPassword: yup.string().required('Current password is required'),
    newPassword: yup.string().min(6, 'New password must be at least 6 characters').required('New password is required'),
    confirmPassword: yup
        .string()
        .oneOf([yup.ref('newPassword')], 'Passwords must match')
        .required('Please confirm your new password'),
});


const PasswordUpdate = () => {

    const toast = useToast();
    const user = JSON.parse(localStorage.getItem("user"));

    const {
        register,
        handleSubmit,
        formState: { errors, isSubmitting },
        reset,
    } = useForm({
        resolver: yupResolver(schema),
    });

    const onSubmit = async (data) => {
        data.uId = user.uId;
        data.authToken = user.authToken;
        try {
            const res = await CommonService.updatePassword(data);
            if (res.statusCode === 200) {
                toast({
                    title: res.message,
                    description: 'Your password has been successfully updated.',
                    status: 'success',
                    duration: 3000,
                    isClosable: true,
                    position: 'top-right',
                });
            }
        } catch (error) {
            if (error.response?.status === 401) {
                toast({
                    title: error.response.data.message,
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                    position: 'top-right',
                });
            } else {

                toast({
                    title: "Something went wrong. Please try again",
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                    position: 'top-right',
                });
                console.error(error);
            }
        }

        reset();
    };

    return (
        <Box maxW="1000px" mx="auto" px={4}>
            <Box maxW="900px" mx="auto" mt={2}>
                {/* Card Header */}
                <Box bg="blue.500" color="white" py={3} px={6} borderTopRadius="lg">
                    <Heading size="sm" textAlign="center">
                        Update Password
                    </Heading>
                </Box>

                {/* Card Body */}
                <Box p={6} bg='white'>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <VStack spacing={4}>
                            <FormControl isInvalid={errors.currentPassword}>
                                <FormLabel fontSize="sm">Current Password</FormLabel>
                                <Input type="password" {...register('currentPassword')} size="sm" placeholder='Current Password' />
                                <FormErrorMessage>{errors.currentPassword?.message}</FormErrorMessage>
                            </FormControl>

                            <FormControl isInvalid={errors.newPassword}>
                                <FormLabel fontSize="sm">New Password</FormLabel>
                                <Input type="password" {...register('newPassword')} size="sm" placeholder='New Password' />
                                <FormErrorMessage>{errors.newPassword?.message}</FormErrorMessage>
                            </FormControl>

                            <FormControl isInvalid={errors.confirmPassword}>
                                <FormLabel fontSize="sm">Confirm New Password</FormLabel>
                                <Input type="password" {...register('confirmPassword')} size="sm" placeholder='Confirm Password' />
                                <FormErrorMessage>{errors.confirmPassword?.message}</FormErrorMessage>
                            </FormControl>

                            <Box textAlign="center" pt={4}>
                                <Button
                                    type="submit"
                                    isLoading={isSubmitting}
                                    size="sm"
                                    bg="#62a13b"
                                    color="white"
                                    _hover={{ bg: "#538d32" }}
                                    boxShadow="lg"
                                    px={10}
                                    py={2}
                                    borderRadius="full"
                                >
                                    Update Password
                                </Button>
                            </Box>

                        </VStack>
                    </form>
                </Box>
            </Box>
        </Box>

    )
}

export default PasswordUpdate
